import { render, staticRenderFns } from "./right-panel.vue?vue&type=template&id=f0d57854&scoped=true&"
import script from "./right-panel.vue?vue&type=script&lang=js&"
export * from "./right-panel.vue?vue&type=script&lang=js&"
import style0 from "./right-panel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./right-panel.vue?vue&type=style&index=1&id=f0d57854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d57854",
  null
  
)

export default component.exports